import * as yup from 'yup'

// No password. It is chosen on the page the mailed link opens, by whoever reads
// that inbox -- retrieve_password.ts holds the fields that ask for it.
export const signUpSchema = yup
  .object({
    name: yup.string().required(),
    surname: yup.string().required(),
    email: yup.string().email().required(),
    legalAge: yup
      .boolean()
      .required('You must be 18 years of age or have parental approval.')
      .oneOf([true], 'You must be 18 years of age or have parental approval.'),
    termsOfService: yup
      .boolean()
      .required('The terms and conditions must be accepted.')
      .oneOf([true], 'The terms and conditions must be accepted.'),
  })
  .required()
